module.exports = __webpack_public_path__ + "img/indicator-loading.437af180.gif";